import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.components.EmergencyStatus.title',
    defaultMessage: 'Emergency status',
  },
  unknown: {
    id: 'app.components.EmergencyStatus.unknown',
    defaultMessage: "You haven't reported your status yet",
  },
  acknowledged: {
    id: 'app.components.EmergencyStatus.acknowledged',
    defaultMessage: 'You have acknowledged the emergency situation',
  },
  acknowledge: {
    id: 'app.components.EmergencyStatus.acknowledge',
    defaultMessage: "Read and understood — I'll get myself to safety",
  },
  reportAsSafe: {
    id: 'app.components.EmergencyStatus.reportAsSafe',
    defaultMessage: 'I am safe',
  },
  safe: {
    id: 'app.components.EmergencyStatus.safe',
    defaultMessage: 'You are safe',
  },
});
